import {AccountingMatrixDatagridGrid} from '../../components/AccountingMatrixDatagridGrid';
import {getAccountingMatrixDatagridM101CashConfig} from './getAccountingMatrixDatagridM101CashConfig';

export function AccountingMatrixDatagridM101Cash() {
  return <AccountingMatrixDatagridGrid config={getAccountingMatrixDatagridM101CashConfig()} />;
}
